var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._v("\n    Contacts PAGE\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }